import React from 'react';
import { connect } from "react-redux";
import ClientList from './List.js'
import Search from './Search.js'
import { FaPlus } from 'react-icons/fa'
import './main.scss'

export class Main extends React.Component{
	constructor(props) {
		super(props);
	
		document.title= "Opći podaci"
		this.state={
			error: false,
			signin: true,
			userName: "",
			password: "",
		} 
	}

    render(){  
      
        return(    
            <main style={{}}>                
                <header>
                    <h1>
                        Klijenti
                    </h1>      
                </header>                

                <div style={{padding: "0 40px 0 40px"}}>
                    <a 
                        href="#/Admin/client/create"
                        className="btn btn-success"  
                        style={{fontSize: "16px", float: "right"}}
                    >
                        <FaPlus size={20} /> <span style={{verticalAlign: "middle"}}>Kreiraj</span>
                    </a>
                </div>

                <Search />

                <div>
                    <ClientList />
                </div> 
            </main>
    )
    }  
}

const mapStateToProps = state => {
    return {
        userLoggedIn: state.user.userLoggedIn,
        asideToggled: state.client.asideToggled,
		adminProps: state.admin,
		client: state.client,
		role: state.user.role
    };
  };
  
  const mapDispatchToProps = dispatch => {
    return {
      mapState: (type, data) => dispatch({ type: type, data: data}),
      API: (type, data) => dispatch({ type: type, data: data})
    };
  };
  
  
  
  export default connect(
    mapStateToProps,
    mapDispatchToProps
  )(Main);
